import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const DiskStructureScheduling = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Disk Structure and Scheduling Algorithms"
    videos={[
      "https://www.youtube.com/embed/m1oNigNpT5M?si=lZUAjh5azo_UpqIv",
      "https://www.youtube.com/embed/dEt7mr9R_Z8?si=gx_dZTkEr_BsK56C",
      "https://www.youtube.com/embed/p48PdudrrgU?si=malDGun1Sq0CCdAw",
      "https://www.youtube.com/embed/eME2bckEFQw?si=mGNpMaSv14fJhcGS",
      "https://www.youtube.com/embed/Ft5o11WJ2Bc?si=H6_oIuR9Q9yuOH7u",
      "https://www.youtube.com/embed/xxRvJ-ykioo?si=L89EFboqHps-cISZ",
      "https://www.youtube.com/embed/0Up1_l8LNXs?si=1prlDeDKSGs1tDVj",
      "https://www.youtube.com/embed/F2Dno5j1G1M?si=dsD720cBkNqHu3Cu"
    ]}
    takeaways={[]}
    questions={[
      "1) Consider an operating system capable of loading and executing a single sequential user process at a time. The disk head scheduling algorithm used is First Come First Served (FCFS). If FCFS is replaced by Shortest Seek Time First (SSTF), claimed by the vendor to give 50% better benchmark results, what is the expected improvement in the I/O performance of user programs?",
      "2) Explain SSTF approach in detail.",
      "3) Consider a disk with 200 tracks and the queue has random requests from different processes in the order: 87, 170, 40, 150, 36, 72, 66, and 15. Initially arm is at 60. Find the total Seek length using FIFO, SSTF, SCAN and LOOK algorithm (for SCAN and LOOK, arm movement towards outer track).",
      "4) Evaluate the total distance (in cylinders) that the disk arm will move to satisfy all the pending requests for the following disk scheduling algorithms: FCFS, SSTF, SCAN, LOOK, C-SCAN, and C-LOOK. The disk drive has 200 cylinders, numbered 0 to 199. The drive is currently at cylinder 55 and the previous request was at cylinder 35. The queue of pending requests, in FIFO order, is: 20, 15, 150, 90, 70, 30, 45, 170, 60, 195. Depict the disk scheduling algorithms with a neat sketch for the scenario given above.",
      "5) Given a disk with 200 tracks (0 to 199) and the current head position at track 150, analyze the total number of tracks traversed to satisfy a series of requests (120, 78, 90, 38, 160, 63, 198, 10, and 75) using different disk scheduling algorithms: FCFS, SSTF, SCAN, and C-SCAN. Evaluate how each algorithm's strategy influences the total distance traveled by the disk head. Based on your analysis, which algorithm would you recommend for optimizing performance in high-traffic scenarios, and why? Discuss the implications of your choice for system responsiveness and efficiency."
    ]}
    exampleVideos={[]}
  />
);
}

export default DiskStructureScheduling;
